module.exports = __webpack_public_path__ + "static/img/invest-consume11.663baf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume11.jpg
// module id = ZHzI
// module chunks = 0